import React from "react";
import { EMAIL_FIELD_NAME, EmailValidationWrapperPropsType } from "./type";
import FormTextField from "../../../../../../shared/form/fields/textField";
import FormContainer from "../../../../../../shared/form";
import { FormikProps } from "formik";
import useEmailValidationWrapperService from "./service";
import ButtonType from "../../../../../../shared/enums/ButtonTypes";
import Button from "../../../../../../shared/components/button";
import { useCopies } from "../../../../../../shared/hooks/useCopies";
import DynamicFieldLabel from "shared/form/renderer/components/DynamicFieldLabel";
import { SchemaField } from "shared/form/renderer/types/SchemaField";
import ButtonGroup from "shared/components/button/components/buttonGroup";

export default function EmailValidationWrapper(props: EmailValidationWrapperPropsType) {
  const copies = useCopies();
  const service = useEmailValidationWrapperService(props);
  if (!service.workEmailFieldDetails) {
    //   This condition should not arise.
    return null;
  }
  return (
    <div className="emailValidationWrapper">
      <FormContainer
        innerRef={service.formRef}
        initialValues={service.formInitialValues}
        validationSchema={service.validationSchema}
        onSubmit={service.formSubmitHandler}
        enableReinitialize>
        {(formikProps: FormikProps<typeof service.formInitialValues>) => {
          return (
            <FormContainer.Form>
              <FormTextField
                label={<DynamicFieldLabel schemaObj={service.workEmailFieldDetails as SchemaField} />}
                name={EMAIL_FIELD_NAME}
                placeholder={service.workEmailFieldDetails?.placeholderLabel}
                required={true}
                className={"transformToLowerCase"}
              />
              <ButtonGroup inlineFormButtons>
                <Button label={copies.get("next")} type={ButtonType.SUBMIT} />
              </ButtonGroup>
            </FormContainer.Form>
          );
        }}
      </FormContainer>
    </div>
  );
}
